var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "gwnl-web-position-detail-skills-standard",
      class: { mt36: _vm.tagStyle && _vm.type === 1 },
    },
    [
      _c(
        "div",
        { staticClass: "gwnl-web-position-detail-skills-standard-header" },
        [
          _c(
            "div",
            {
              staticClass:
                "flex-1 align-items-center ellipsis font-size-14 lh22",
            },
            [
              _c("yxt-svg", {
                staticClass: "mr8",
                staticStyle: { width: "20px", height: "20px" },
                attrs: {
                  "remote-url": _vm.gwnlMediaDomain + "svg/",
                  width: "20",
                  height: "20",
                  "icon-class": _vm.type === 1 ? "adv" : "disadv",
                },
              }),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.type === 0
                      ? _vm.$t("pc_gwnl_ability_standard")
                      : _vm.type === 1
                      ? _vm.$t("pc_gwnl_web_advantageAbility")
                      : _vm.$t("pc_gwnl_web_disadvantageAbility")
                  ) +
                  "\n    "
              ),
            ],
            1
          ),
          _vm.detail.length > 0 && !_vm.tagStyle
            ? _vm._l(_vm.legends, function (legend, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass:
                      "standard-size-12 color-gray-7 ml16 align-items-center lh20",
                  },
                  [
                    _c("i", {
                      staticClass: "skill_detail-legend mr8",
                      class: {
                        "bg-gray": index === 0,
                        "bg-yellow": index > 0 && _vm.type === 2,
                        "bg-blue": index > 0 && _vm.type === 1,
                      },
                    }),
                    _vm._v(_vm._s(legend.label) + "\n      "),
                  ]
                )
              })
            : _vm._e(),
        ],
        2
      ),
      _vm.detail.length > 0
        ? _c(
            "div",
            {
              staticClass:
                "gwnl-web-position-detail-skills-standard-content mt16",
            },
            [
              !_vm.tagStyle
                ? _vm._l(_vm.detail, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass:
                          "gwnl-web-position-detail-skills-standard-content-item mb24",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "standard-size-12 color-gray-9 flex mb10",
                          },
                          [
                            _c(
                              "yxtf-tooltip",
                              {
                                attrs: {
                                  "open-filter": "",
                                  content: item.name,
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "ellipsis maxWidth142" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.name) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._l(_vm.legends, function (legend, index) {
                          return _c("detail-progress", {
                            key: index,
                            attrs: {
                              color:
                                index > 0
                                  ? _vm.type === 2
                                    ? "#FA8C16"
                                    : "#4943FF"
                                  : "#cdd1e0",
                              level: +item[legend.propName],
                              "level-name": item[legend.propLevelName],
                              range4show: item[legend.propRange],
                            },
                          })
                        }),
                      ],
                      2
                    )
                  })
                : _vm._l(_vm.detail, function (item, itemIndex) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass:
                          "gwnl-web-position-detail-skills-standard-content-item-tags ellipsis font-size-12 lh17 pv6 ph12 mt14 maxWidth158",
                        class: { mr16: itemIndex !== _vm.detail.length - 1 },
                      },
                      [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
                    )
                  }),
            ],
            2
          )
        : _c("yxtf-empty", { staticClass: "mb47" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }